module.exports = __webpack_public_path__ + "18938b3fbf54569624d87db7dedd8360.svg";